/* Refillia: barra fissa "Aggiungi al carrello" nelle pagine prodotto, compare quando il pulsante principale non si vede più */
(function () {
  function avvia() {
    var add = document.querySelector('[data-rfpt-add], [data-rf-add]');
    if (!add || document.querySelector('.rf-sticky')) return;
    var titolo = (document.querySelector('.rfpt-titolo, .rf-pdp h1, h1') || {}).textContent || '';
    var foto = document.querySelector('[data-rfpt-foto], .rf-pdp__sl--flacone img, .rf-pdp__pista img');
    var bar = document.createElement('div');
    bar.className = 'rf-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="rf-sticky__in">' +
      '<span class="rf-sticky__foto">' + (foto ? '<img src="' + (foto.currentSrc || foto.src) + '" alt="" width="48" height="48">' : '') + '</span>' +
      '<span class="rf-sticky__t"><b></b><small></small></span>' +
      '<button type="button" class="rf-sticky__btn" tabindex="-1"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg><span>Aggiungi al carrello</span><em></em></button></div>';
    bar.querySelector('b').textContent = titolo.trim();
    document.body.appendChild(bar);
    var prezzoEl = bar.querySelector('em'), formato = bar.querySelector('small'), btn = bar.querySelector('button');

    function leggi() {
      var p = document.querySelector('[data-rfpt-add-prezzo], [data-rf-prezzo]');
      prezzoEl.textContent = p ? p.textContent.trim() : '';
      var scelto = document.querySelector('.rfpt-fm[aria-pressed="true"] b, .rfpt-fr[aria-pressed="true"], [data-rf-seg] button.on .rf-pdp__c-l, [data-rf-seg] button.on b');
      formato.textContent = scelto ? scelto.textContent.trim() : '';
      btn.disabled = add.disabled;
    }
    btn.addEventListener('click', function () { add.click(); });

    function mostra(si) {
      bar.classList.toggle('su', si);
      bar.setAttribute('aria-hidden', si ? 'false' : 'true');
      btn.tabIndex = si ? 0 : -1;
      document.documentElement.classList.toggle('rf-sticky-su', si);
      if (si) leggi();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (v) {
        var e = v[0];
        mostra(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(add);
    }
    var mo = new MutationObserver(leggi);
    mo.observe(add, { childList: true, subtree: true, characterData: true, attributes: true });
    leggi();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
})();
